import { render, staticRenderFns } from "./AkLinkField.vue?vue&type=template&id=70f81126&"
import script from "./AkLinkField.vue?vue&type=script&lang=js&"
export * from "./AkLinkField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports